var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10666 2.55395C2.27204 2.22692 2.61212 2 3.00008 2H19.0001C19.388 2 19.7281 2.22692 19.8935 2.55395L11.0001 8.77934L2.10666 2.55395ZM0.000134389 2.98266C-2.77873e-05 2.99253 -4.41349e-05 3.00239 8.4877e-05 3.01225V15C8.4877e-05 16.6523 1.3478 18 3.00008 18H19.0001C20.6524 18 22.0001 16.6523 22.0001 15V3.01236C22.0002 3.00242 22.0002 2.99247 22 2.98251C21.9906 1.33822 20.6465 0 19.0001 0H3.00008C1.35358 0 0.00952528 1.3383 0.000134389 2.98266ZM20.0001 4.92066V15C20.0001 15.5477 19.5478 16 19.0001 16H3.00008C2.45237 16 2.00008 15.5477 2.00008 15V4.92066L10.4266 10.8192C10.7709 11.0603 11.2292 11.0603 11.5735 10.8192L20.0001 4.92066Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d5f1a840.svg";
export { ForwardRef as ReactComponent };